import DFPAdSlot from 'DFPAdSlot';
import MCP from 'MCP';

const defaults = {
	instanceTargeting: {
		enabled: true,
		key: 'pos',
		valueFormat: '{slotType}_{instance}',
	}
};

/**
 * Adds slot instance to ad request targeting
 */
export default function setInstanceTargeting(MCP: MCP): void {
	MCP.loaded.then(() => {
		const { instanceTargeting: configuration } = MCP.Configurator?.getConfiguration({ defaults });
		
		if (!configuration?.enabled) return;
		
		// Add the targeting to the ad slots before they are refreshed
		const addTargetingBeforeRefresh = ({ slots }: { slots: Map<HTMLElement, DFPAdSlot> }) => {
			Array.from(slots.values()).forEach((slot: DFPAdSlot) => {
				const slotType = slot.type.replace(/^ad_/, '');

				const valueFormat = slot?.meta?.instanceTargetingValueFormat || configuration.valueFormat;

				const value: string = valueFormat
					.replaceAll('{instance}', slot.instance.toString())
					.replaceAll('{slotType}', slotType);
					
				if (!configuration.key || !value) return;
				slot.setTargeting(configuration.key, value);
			});
		};

		MCP.addEventListener('beforeRefreshSlots', addTargetingBeforeRefresh);
	});
}
